import {colors} from "../../../../../../../enums/colors";
import {
    DAYS_MODEL,
    DEFAULT_LATITUDE,
    DEFAULT_LONGITUDE,
    getTimeFormatFromTime,
    getToTime
} from "../../../../../../../Apis/functions";
import L from "leaflet";
import {DRAW_MODE} from "../../../../../Traffic/Manage/Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 22 de 01 de 2026
 */

export const ATTENDANCE_GEOFENCE_MODE = {
    MONITORING_ONLY: {
        id: 'MONITORING_ONLY',
        trans:'monitoring_only_none'
    },
    WARNING_MODE: {
        id: 'WARNING_MODE',
        trans:'warning_mode_soft'
    },
    RESTRICTED_ACCESS: {
        id: 'RESTRICTED_ACCESS',
        trans:'restricted_access_hard'
    },
    getById: function (id) {
        const row = Object.entries(ATTENDANCE_GEOFENCE_MODE).find(([ key, data]) => data?.id === id);
        return row?.[1] || null;
    }
};

export const ATTENDANCE_GEOFENCES_MODEL = {
    geofenceId: null,
    geofenceConfigId: null,
    name: '',
    description: '',
    mode: null,
    devices : null,
    opening: null,
    closing: null,
    strokeColor: colors.primary500,
    strokeWidth: 2,
    fillColor: colors.primary600,
    schedule: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
    },
    isValidDetails: function () {
        return this.name.trim() !== ''
            && this.description.trim() !== ''
            && this.isValidMode()
            && Array.isArray(this.devices) && this.devices.length > 0;
    },
    isValidSchedule: function (dayArray) {
        if (!Array.isArray(dayArray) || dayArray.length === 0) return false;
        if (!this.opening || !this.closing) return false;

        return this.closing > this.opening;
    },
    isValidArea: function (geofences) {
        return geofences.length > 0;
    },
    isValidMode: function () {
        return this.mode !== null && this.mode !== ''
    },
    toRegister: function (coordinates, dayArray) {
        DAYS_MODEL.forEach(e => {
            this.schedule[e.key] = dayArray.includes(e.value) ? 1 : 0;
        });
        let schedule = Object.entries(this.schedule)?.map(([key, value]) => value)
        schedule = schedule.join(" ");
        schedule = schedule + " " + getTimeFormatFromTime(this.opening) + "-" + getTimeFormatFromTime(this.closing)

        return {
            id: this.geofenceId,
            name: this.name,
            description: this.description,
            attendanceGeofenceConfigDto: {
                id: this.geofenceConfigId,
                geofenceId: this.geofenceId,
                mode: this.mode,
                strokeColor: this.strokeColor,
                fillColor: this.fillColor,
                strokeWidth: this.strokeWidth,
                schedule: schedule,
                devices: this.devices?.map(e => ({ id: e.id}))
            },
            coordinates: coordinates.map(([latitude, longitude]) => {
                return {
                    latitude: latitude,
                    longitude: longitude
                }
            })
        };
    },
    toSet: function (data) {
        let schedule = this.toSetDays(data?.attendanceGeofenceConfigDto?.schedule)

        return {
            ...this,
            geofenceId: data.id,
            geofenceConfigId: data.attendanceGeofenceConfigDto.id,
            name: data.name,
            description: data.description,
            mode: data.attendanceGeofenceConfigDto.mode,
            devices: data.attendanceGeofenceConfigDto.devices,
            opening: getToTime(schedule.opening),
            closing: getToTime(schedule.closing),
            strokeColor: data.attendanceGeofenceConfigDto.strokeColor,
            strokeWidth:  data.attendanceGeofenceConfigDto.strokeWidth,
            fillColor: data.attendanceGeofenceConfigDto.fillColor,
        };
    },
    toSetCoordinates: function (coordinates) {
        return coordinates.map(c => {
            return [ c.latitude, c.longitude]
        })
    },
    toSetDays: function (schedule) {
        const parts = schedule?.trim()?.split(" ") || [];
        const timeRange = parts.pop();
        const [opening, closing] = timeRange.split("-");
        const days = parts.map(Number);

        let aux = [];
        days.map((d, index) => {
            if (d) {
                let day = DAYS_MODEL.find(obj => obj.value === index);
                aux.push(day.value);
            }
        });


        return {
            days: aux,
            opening,
            closing
        };
    },
    toSetMap: function (e, setDayArray) {
        let schedule = ATTENDANCE_GEOFENCES_MODEL.toSetDays(e?.attendanceGeofenceConfigDto?.schedule);
        if(setDayArray) setDayArray(schedule.days);
        let coordinates= this.toSetCoordinates(e.coordinates);

        return {
            ...e,
            ...e.attendanceGeofenceConfigDto,
            geofenceId:e.id,
            geofenceConfigId:e.attendanceGeofenceConfigDto.id,
            mode: e.attendanceGeofenceConfigDto.mode,
            opening: schedule.opening,
            closing: schedule.closing,
            coordinates,
            type: coordinates.length === 4 ? DRAW_MODE.RECTANGLE : DRAW_MODE.POLYGON
        };
    },
    buildGeofenceListMap : function (data, setDayArray) {
        return data.map(e => {
            return this.toSetMap(e, setDayArray);
        });
    },
    getGeofenceCenter: function (geofence){
        if(!geofence?.type || !geofence.coordinates )
            return [DEFAULT_LATITUDE, DEFAULT_LONGITUDE];

        if(geofence?.type === DRAW_MODE.RECTANGLE){
            const polygon = L.polygon(geofence.coordinates);
            const latLong = polygon.getBounds().getCenter();
            return [latLong.lat, latLong.lng];
        }
        const rectangle = L.rectangle(geofence.coordinates);
        const latLong = rectangle.getBounds().getCenter();
        return [latLong.lat, latLong.lng];
    }
};


export const CREATE_STEP = {
    DETAILS: 0,
    ACTIVE_SCHEDULE: 1,
    DEFINE_AREA: 2,
    SUMMARY: 3,
};

//Checks if the closing time is before the opening time.
export const isCloseTimeNotValid = (opening, closing) => {
    const openingTime = getTimeFormatFromTime(opening);
    const closingTime = getTimeFormatFromTime(closing);
    if (!openingTime || !closingTime) return false;
    return closingTime < openingTime;
};
